/* tslint:disable */
/* eslint-disable */
export enum MfaType {
  None = 0,
  Mobile = 1,
  Email = 2,
  AuthApp = 3
}
